import { Card, CardContent, Container, Grid, TextField } from "@mui/material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultFooter from "examples/Footers/DefaultFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import footerRoutes from "footer.routes";
import routes from "routes";
// Images
import bgImage from "assets/images/front2.jpeg";
import { useTranslation } from "react-i18next";
import minefop from "assets/images/minefop.jpg";
import { useEffect, useState } from "react";
import MKButton from "components/MKButton";
import { useLocation, useNavigate } from "react-router-dom";
import usePost from "hooks/usePost";
import { config } from "constants/config/config";

function Verification() {
    const { t } = useTranslation();
    const [code, setCode] = useState("");
    const [errors, setErrors] = useState({});
    const [errorData, setErrorData] = useState("");
    const [postData, loading, error, data] = usePost(`${config.app.api_url}/auth/email-verification`);
    const [postSendCode] = usePost(`${config.app.api_url}/auth/send-email-verification`);
    const navigate = useNavigate();

    const location = useLocation();
    console.log("🚀 ~ Verification ~ location:", location)

    // Récupérer les données passées via navigate
    const mail = location.state?.mail;
    const userData = location.state?.data;
    const [updatedEmail, setUpdatedEmail] = useState("");
    useEffect(() => {
        (mail || userData) && setUpdatedEmail(mail || userData?.user?.mail)
    }, [location]);
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Initialiser les erreurs à vide
        const newErrors = {};

        // Valider les champs
        if (!code) newErrors.code = t("Verification.errors.code");

        // Vérifier s'il y a des erreurs
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors); // Si oui, afficher les erreurs
        } else {
            // Logique à exécuter si tous les champs sont remplis
            await postData({ email: updatedEmail, code });
        }
    };

    useEffect(() => {
        console.log("DATA ", data)
        if (data && data?.status == 200 && data?.user) {
            // Si la requête a réussi et que nous avons un token, appeler login
            navigate("/login")
        } else {
            setErrorData(data?.message)
        }
    }, [data])

    return (
        <MKBox sx={{ background: "#fff" }}>
            <DefaultNavbar
                routes={routes}
                sticky={true}
                action={{
                    type: "external",
                    route: "https://www.creative-tim.com/product/material-kit-react",
                    label: "free download",
                    color: "default",
                }}
                transparent
                light
            />
            <MKBox
                minHeight="45vh"
                width="100%"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.6),
                            rgba(gradients.dark.state, 0.6)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            >
                <Container>
                    <Grid
                        container
                        item
                        xs={12}
                        flexDirection="column"
                        sx={{ textAlign: "left", mt: 10 }}
                    >
                        <MKTypography
                            variant="h2"
                            color="white"
                        >
                            {t("Verification.title")}
                        </MKTypography>
                    </Grid>
                </Container>
            </MKBox>
            <Container>
                <Grid className="d-flex justify-content-center">
                    <img
                        className="d-block w-20"
                        src={minefop}
                        style={{ height: '30vh' }}
                    />
                </Grid>
                <Grid className="d-flex justify-content-center">
                    <Card style={{ background: "rgba(8, 56, 4, 0.72)", width: "150vh" }}>
                        <CardContent style={{ textAlign: "center" }}>
                            <MKTypography
                                variant="h5"
                                color="white"
                            >
                                {t("Verification.card.title")}
                            </MKTypography>
                            {error && <MKTypography
                                variant="subtitle2"
                                color="white"
                                style={{ background: "red", mt: 2 }}
                            >
                                {error}
                            </MKTypography>}
                            {errorData && <MKTypography
                                variant="subtitle2"
                                color="white"
                                style={{ background: "red", mt: 2 }}
                            >
                                {errorData}
                            </MKTypography>}
                            <Container>
                                <form onSubmit={handleSubmit}>
                                    <MKBox>
                                        <TextField
                                            required
                                            sx={{
                                                mt: 5,
                                                width: "100%",
                                                "& .MuiInputBase-input": { color: "#fff" }, // Couleur du texte
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": {
                                                        borderColor: "#fff", // Couleur de la bordure
                                                    },
                                                    "&:hover fieldset": {
                                                        borderColor: "#fff",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "#fff", // Couleur de la bordure en mode focus
                                                    },
                                                },
                                                "& .MuiInputLabel-root": { color: "#fff" }, // Couleur du label
                                                "& .MuiInputLabel-root.Mui-focused": { color: "#fff" }, // Couleur du label en focus
                                                "& .MuiOutlinedInput-input::placeholder": {
                                                    color: "#fff", // Couleur du placeholder
                                                    opacity: 0.1, // Pour que l'opacité du placeholder soit contrôlée
                                                },
                                            }}
                                            value={updatedEmail}
                                            onChange={(e) => setUpdatedEmail(e.target.value)}
                                            // disabled
                                            id="outlined-required"
                                            type="email"
                                            label={t("Login.card.email")}
                                            InputLabelProps={{ shrink: true }}
                                            error={!!errors.email}
                                            helperText={errors.email}
                                        />
                                        <TextField
                                            required
                                            sx={{
                                                mt: 2,
                                                width: "100%",
                                                "& .MuiInputBase-input": { color: "#fff" }, // Couleur du texte
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": {
                                                        borderColor: "#fff", // Couleur de la bordure
                                                    },
                                                    "&:hover fieldset": {
                                                        borderColor: "#fff",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "#fff", // Couleur de la bordure en mode focus
                                                    },
                                                },
                                                "& .MuiInputLabel-root": { color: "#fff" }, // Couleur du label
                                                "& .MuiInputLabel-root.Mui-focused": { color: "#fff" }, // Couleur du label en focus
                                                "& .MuiOutlinedInput-input::placeholder": {
                                                    color: "#fff", // Couleur du placeholder
                                                    opacity: 0.1, // Pour que l'opacité du placeholder soit contrôlée
                                                },
                                            }}
                                            value={code}
                                            onChange={(e) => {
                                                setCode(e.target.value);
                                            }}
                                            placeholder="45342"
                                            id="outlined-required"
                                            type="text"
                                            label={t("Verification.card.code")}
                                            InputLabelProps={{ shrink: true }}
                                            error={!!errors.code}
                                            helperText={errors.code}
                                        />


                                        <MKBox
                                            onClick={()=>postSendCode({ email: updatedEmail })}
                                         >

                                            <MKTypography
                                                mt={3}
                                                variant="subtitle2"
                                                color="white"
                                                sx={{ textAlign: 'left' }}
                                            >
                                                {t("Verification.card.receive")}
                                            </MKTypography>
                                        </MKBox>
                                        <MKButton
                                            disabled={loading}
                                            variant="contained"
                                            color="white"
                                            size="large"
                                            component="a"
                                            onClick={handleSubmit}
                                            sx={{ mt: 5, alignSelf: 'center', height: 'fit-content' }}
                                        >
                                            {loading ? t("Verification.card.loading") : t("Verification.card.btn")}
                                        </MKButton>
                                    </MKBox>
                                </form>
                            </Container>
                        </CardContent>
                    </Card>
                </Grid>
            </Container>
            <MKBox pt={6} px={1} mt={6}>
                <DefaultFooter content={footerRoutes} />
            </MKBox>
        </MKBox>
    )
}

export default Verification;